import { Container, ContainerProps } from '@mui/material'
import { CONTENT_MAX_WIDTH, SPACE } from '../styles/layout'

const ZContainer = (props: ContainerProps) => {
  const { style, children, sx, ...rest } = props

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        maxWidth: CONTENT_MAX_WIDTH,
        ...(sx as object),
      }}
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        width: '100%',
        margin: '0 auto',
        paddingTop: SPACE['5xl'],
        ...style,
      }}
      {...rest}
    >
      {children}
    </Container>
  )
}

export default ZContainer
